import * as React from "react";
import { Icon } from "@sproutsocial/seeds-react-icon";
import { cn } from "./cn";

export interface StyledChevronProps extends React.ComponentProps<"div"> {
  $isOpen?: boolean;
}

export const StyledChevron = React.forwardRef<
  HTMLDivElement,
  StyledChevronProps
>(({ $isOpen, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={cn(
      "seeds-menu-chevron",
      { "seeds-menu-chevron--open": !!$isOpen },
      className
    )}
    {...rest}
  />
));
StyledChevron.displayName = "StyledChevron";

export function ChevronIcon() {
  return <Icon name="chevron-down-outline" fixedWidth aria-hidden />;
}

export function ClearIcon() {
  return <Icon name="circle-x-outline" fixedWidth aria-hidden size="mini" />;
}

export function CheckIcon() {
  return <Icon name="check-outline" fixedWidth aria-hidden />;
}
